import { useI18n } from '../../i18n/useI18n';

type ChatbotConversationMessageListHeaderProps = {
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
  hasMessages: boolean;
};

export function ChatbotConversationMessageListHeader({
  isFetchingNextPage,
  hasNextPage,
  hasMessages,
}: ChatbotConversationMessageListHeaderProps) {
  const { translate } = useI18n();

  return (
    <div className="liks-chat-message-list__header">
      {isFetchingNextPage && (
        <div
          className="liks-chat-message-list__loading-more"
          role="status"
          aria-live="polite"
        >
          <span
            className="liks-chat-message-list__spinner"
            aria-hidden="true"
          />
          <span>{translate('platformChat.loadingOlderMessages')}</span>
        </div>
      )}
      {!hasNextPage && hasMessages && !isFetchingNextPage && (
        <p className="liks-chat-message-list__start">
          {translate('platformChat.startOfChat')}
        </p>
      )}
    </div>
  );
}
